import { emptyOrder } from '../components/delivery-company-components/orders/create-order-form/create-order-form.utils';
import { OrderType } from '../interfaces/delivery-company/orders';

export interface Decoding {
  type: 'temporary' | 'permanent' | 'error';
  id: string;
  current_package: number;
  number_of_packages: number;
}

export interface DecodingWithOrderVal extends Decoding {
  order: OrderType;
}

export const TemporaryPackagePrefixes = ['TMP_', 'PT'];

export const PreferredTemporaryPackagePackage = 'PT'

export const isTemporaryPackage = (packageId: string): boolean => {
  if (!packageId) return false;
  return TemporaryPackagePrefixes.some(prefix => packageId.startsWith(prefix))
}

const formatpackagecount = (count: number) => {
  return count.toString().padStart(2, '0');
};

export const encodePermanentPackage = (
  order: OrderType,
  current_package: number
): string => {
  return `${order.order_id}${formatpackagecount(current_package)}${formatpackagecount(order.number_of_packages)}`;
};

export const decode = (encoded_val: string): Decoding => {
  try {
    if (!isTemporaryPackage(encoded_val)) {
      const len = encoded_val.length;
      const current_package = encoded_val.substring(len - 4, len - 2);
      const number_of_packages = encoded_val.substring(len - 2);
      return {
        type: 'permanent',
        id: encoded_val.substring(0, len - 4),
        current_package: parseInt(current_package),
        number_of_packages: parseInt(number_of_packages),
      };
    } else
      return {
        type: 'temporary',
        id: encoded_val,
        current_package: 1,
        number_of_packages: 1,
      };
  } catch {
    return {
      type: 'error',
      id: '',
      current_package: 0,
      number_of_packages: 0,
    };
  }
};

export const transformOrdersToDecodingWithOrderVal = (orders: OrderType[]) => {
  const res: DecodingWithOrderVal[] = [];
  orders.forEach((order) => {
    for (let i = 0; i < order.number_of_packages; i++)
      res.push({
        id: order.order_id,
        number_of_packages: order.number_of_packages,
        current_package: i + 1,
        type: 'permanent',
        order: order,
      });
  });
  console.log('res = ', res);
  return res;
};

export const transformPendingBarcodesToDecodingWithOrderVal = (
  pending_barcodes: string[]
) => {
  const res: DecodingWithOrderVal[] = [];
  pending_barcodes.forEach((barcode) => {
    res.push({ ...decode(barcode), order: emptyOrder });
  });
  return res;
};

export function same(
  decoding1: DecodingWithOrderVal | Decoding,
  decoding2: DecodingWithOrderVal | Decoding
): boolean {
  return (
    decoding1.type === decoding2.type &&
    decoding1.id === decoding2.id &&
    decoding1.current_package === decoding2.current_package &&
    decoding1.number_of_packages === decoding2.number_of_packages
  );
}

export const generateUID = (decoding: Decoding | DecodingWithOrderVal) => {
  return `${decoding.id}-${decoding.current_package}`;
};
